import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { getStudentIdData } from '../../lib/studentlessonsview'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { useLayout } from '../../Hooks/useLayout'
import { getLessonForGradeColumns } from '../../Data/GradeManagement/LessonForGradeListData'
import LessonForGradeModal from './LessonForGradeModal'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const LessonForGradeList = ({ studentId, isStudent = true }) => {
	const [lessons, setLessons] = useState([])
	const [loading, setLoading] = useState(true)
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [lessonToEdit, setLessonToEdit] = useState(null)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)
	const role = useRoleBasedUrl()
	const layout = useLayout()

	async function getData() {
		try {
			setLoading(true)
			const lessonData = await getStudentIdData(studentId)
			setLessons(lessonData)
		} catch (error) {
			console.error('Error fetching lessons:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (studentId) {
			getData()
		}
	}, [studentId])

	const handleEdit = (lesson) => {
		setLessonToEdit(lesson)
		setIsModalOpen(true)
	}

	const handleAdd = () => {
		setLessonToEdit(null)
		setIsModalOpen(true)
	}

	const toggleModal = () => {
		setIsModalOpen(!isModalOpen)
	}

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleSave = (message) => {
		getData()
		if (message) {
			showToastMessage(message)
		}
	}

	const columns = getLessonForGradeColumns(studentId, isStudent, role, layout, handleEdit)

	if (loading) {
		return (
			<Card className="mb-4">
				<CardBody className="text-center">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-2">Loading lessons...</p>
				</CardBody>
			</Card>
		)
	}

	return (
		<>
			<Card className="mb-4 shadow-sm">
				<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
				<CardBody>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<h3 className="mb-0">Lessons</h3>
						<button onClick={handleAdd} className="btn btn-primary btn-sm">
							<i className="fa fa-plus me-2"></i>
							Add New Course
						</button>
					</div>
					<DataTable
						columns={columns}
						data={lessons}
						pagination
						paginationPerPage={10}
						paginationRowsPerPageOptions={[10, 25, 50]}
						highlightOnHover
						striped
						responsive
						noDataComponent={
							<div className="text-center p-4">
								<p className="text-muted">No courses found</p>
							</div>
						}
						customStyles={{
							headCells: {
								style: {
									fontWeight: 'bold',
									fontSize: '12px',
									backgroundColor: '#f8f9fa'
								}
							}
						}}
					/>
				</CardBody>
			</Card>
			<LessonForGradeModal isOpen={isModalOpen} toggle={toggleModal} studentId={studentId} lessonToEdit={lessonToEdit} onSave={handleSave} />
		</>
	)
}

export { LessonForGradeList }
